import React, { useContext, useEffect, useState } from 'react'
import { DarkModeContext } from '../../global/Theme'
import { useSelector, useDispatch } from 'react-redux'
import ConnectionCard from './ConnectionCard'
import { useHistory } from 'react-router-dom'
import {CopyToClipboard} from 'react-copy-to-clipboard';


export default function ProfileCard() {
    const { isDark } = useContext(DarkModeContext);
    const history = useHistory();
    const dispatch = useDispatch()
    const userDataStore = useSelector(state => state.userState)

    useEffect(() => {
    }, [userDataStore])

    const gotoEditProfile = () => {
        if (userDataStore.isCreator)
            history.push({
                pathname: '/editprofile-creator',
            })
        if (!userDataStore.isCreator)
            history.push({
                pathname: '/editprofile',
            })
    }

    const gotoWallet = () => {
        if (userDataStore.isCreator)
        history.push({
            pathname: '/wallet-creator',
        })
        else if(!userDataStore.isCreator)
        history.push({
            pathname: '/wallet',
        })
    }

    const openCurrentProfile = () => {

        window.open(`https://lovr.online/user/${userDataStore.username}`, 'current_lovr_user')
    }

    const sleep = async (ms) => {
        return new Promise(resolve => setTimeout(resolve, ms))
    }


    return (
        <div id="profileCard">
            <div id="profileCardInfo">
                <div id="profileInfoLeft">
                    <h1>{userDataStore.followersCount}</h1>
                    <p>Lovrs</p>
                </div>
                <div id="profileInfoDP">
                    <img onClick={gotoEditProfile} src={(userDataStore.image === "") ? (userDataStore.isCreator) ? require("../../assets/icons/creator.svg") : require("../../assets/icons/viewer.svg") : userDataStore.image} />
                </div>
                <div id="profileInfoRight">
                    <h1>{userDataStore.followingCount}</h1>
                    <p>Loving</p>
                </div>
            </div>

            <div id="profileCardDetails">
                <div id="profileCardName">
                    <p className={`${isDark ? 'p-dark' : 'p-light'}`}>{userDataStore.name}</p>
                    
                    <CopyToClipboard text={`https://lovr.online/user/${userDataStore.username}`}
                        onCopy={async () => {
                            dispatch({
                                type: 'SET_NOTIFICATION', payload: {
                                    isEnabled: true,
                                    text: 'Link copied to Clipboard',
                                    icon: 'notifcomment.svg'
                                }
                            })
                            await sleep(3000)
                            dispatch({
                                type: 'SET_NOTIFICATION', payload: {
                                    isEnabled: false,
                                    text: '',
                                    icon: ''
                                }
                            })
                        }}>
                    <img src={require('../../assets/icons/pshare.svg')} />
                        
                    </CopyToClipboard>
                </div>
                <div id="profileDescription">
                    <p>{userDataStore.bio}</p>
                </div>
                <div id="editProfileBtn" onClick={gotoEditProfile}>
                    <div>
                        <p>Edit profile</p>
                    </div>
                </div>
                <div className={isDark ? 'profile-wallet-card-dark' : 'profile-wallet-card'}>
                    <p>${userDataStore.balance}</p>
                    <div id="profileWalletButton" onClick={gotoWallet} >
                        <img src={require('../../assets/icons/tip_w.svg')} />
                        <p>Wallet</p>
                    </div>
                </div>

                <div className={isDark ? 'profile-connection-card-dark' : 'profile-connection-card'}>
                    <img src={require('../../assets/icons/url.svg')} />
                    <p>Connections</p>
                </div>

                <div className="profile-connection-row">
                    <ConnectionCard type="website" isActive={(userDataStore.socialMedia != null && userDataStore.socialMedia.website.length > 0) ? true : false} img='website.png' page={(userDataStore.socialMedia !== null && userDataStore.socialMedia.website.length > 0) ? userDataStore.socialMedia.website : "#"} />
                    <ConnectionCard type="instagram" isActive={(userDataStore.socialMedia != null && userDataStore.socialMedia.instagram.length > 0) ? true : false} img='instagram.png' page={(userDataStore.socialMedia !== null && userDataStore.socialMedia.instagram.length > 0) ? userDataStore.socialMedia.instagram : "#"} />
                </div>
                <div className="profile-connection-row">
                    <ConnectionCard type="spotify" isActive={(userDataStore.socialMedia != null && userDataStore.socialMedia.spotify.length > 0) ? true : false} img='spotify.png' page={(userDataStore.socialMedia !== null && userDataStore.socialMedia.spotify.length > 0) ? userDataStore.socialMedia.spotify : "#"} />
                    <ConnectionCard type="tiktok" isActive={(userDataStore.socialMedia != null && userDataStore.socialMedia.tiktok.length > 0) ? true : false} img='tiktok.png' page={(userDataStore.socialMedia !== null && userDataStore.socialMedia.tiktok.length > 0) ? userDataStore.socialMedia.tiktok : "#"} />
                </div>
                <div className="profile-connection-row">
                    <ConnectionCard type="pornhub" isActive={(userDataStore.socialMedia != null && userDataStore.socialMedia.pornhub.length > 0) ? true : false} img='pornhub.png' page={(userDataStore.socialMedia !== null && userDataStore.socialMedia.pornhub.length > 0) ? userDataStore.socialMedia.pornhub : "#"} />
                    <ConnectionCard type="snapchat" isActive={(userDataStore.socialMedia != null && userDataStore.socialMedia.snapchat.length > 0) ? true : false} img='snapchat.png' page={(userDataStore.socialMedia !== null && userDataStore.socialMedia.snapchat.length > 0) ? userDataStore.socialMedia.snapchat : "#"} />
                </div>
                <div className="profile-connection-row">
                    <ConnectionCard type="twitter" isActive={(userDataStore.socialMedia != null && userDataStore.socialMedia.twitter.length > 0) ? true : false} img='twitter.png' page={(userDataStore.socialMedia !== null && userDataStore.socialMedia.twitter.length > 0) ? userDataStore.socialMedia.twitter : "#"} />
                    <ConnectionCard type="twitch" isActive={(userDataStore.socialMedia != null && userDataStore.socialMedia.twitch.length > 0) ? true : false} img='twitch.png' page={(userDataStore.socialMedia !== null && userDataStore.socialMedia.twitch.length > 0) ? userDataStore.socialMedia.twitch : "#"} />
                </div>
            </div>
        </div>
    )
}
